<script>
export default {
  name: 'Home',
  beforeMount() {
    this.$router.push({ name: 'Sites' });
  }
};
</script>

<template>
  <div />
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

// No styles yet
</style>
